var render = function render(){var _vm=this,_c=_vm._self._c;return _c('layout',[_c('router-view'),(_vm.getMsgPopup.message)?_c('confirm-popup',{attrs:{"confirmType":_vm.getMsgPopup.type,"onYesClick":_vm.getMsgPopup.okayCallback,"onNoClick":_vm.getMsgPopup.cancelCallback,"confirmMessage":_vm.getMsgPopup.message}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }